"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsxs, jsx } from 'react/jsx-runtime';
import { EditorTagBadge, EditorTagBadgeIcon } from '../../ComboBox/Badges/EditorTagBadge/index.mjs';
import { SvgIconType } from '../../SvgIcon/svg-icon-type.mjs';
import { forwardRef } from 'react';
import { Truncate } from '../../Truncate/index.mjs';

const LookupFormula = forwardRef((props, ref) => {
  const { formula } = props;
  const isConfigError = Object.entries(formula.value?.query ?? {}).length === 0;
  return /* @__PURE__ */ jsxs(
    EditorTagBadge,
    {
      ref,
      variant: "value",
      disabled: props.disabled,
      onClick: props.onClick,
      onDelete: props.onDelete,
      children: [
        isConfigError && /* @__PURE__ */ jsx(EditorTagBadgeIcon, { type: SvgIconType.AlertTriangle }),
        /* @__PURE__ */ jsx(Truncate, { children: "Select Dynamically" })
      ]
    }
  );
});
LookupFormula.displayName = "LookupFormula";

export { LookupFormula as default };
